var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { Icon } from '../../Icon';
// Utils
import { css } from 'styled-components';
export var getTextButtonStylesByIcon = function (icon, isIconOnRight) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: ", ";\n    gap: ", ";\n\n    ", " {\n      order: ", ";\n    }\n  "], ["\n    display: ", ";\n    gap: ", ";\n\n    ", " {\n      order: ", ";\n    }\n  "])), icon && 'inline-grid', icon && '8px', Icon, isIconOnRight ? '1' : '0');
};
var templateObject_1;
//# sourceMappingURL=getTextButtonStylesByIcon.js.map